import SwitchUserPage from '@/views/login/SwitchUserPage'

export default function SwitchUser() {
  return <SwitchUserPage />
}
